import type { HTMLAttributes } from 'react';

import { cn } from './cn';

type BadgeVariant = 'default' | 'success' | 'warning' | 'error' | 'bamboo' | 'flower' | 'navy';

const variants: Record<BadgeVariant, string> = {
  default: 'bg-cream-200 text-navy-900',
  success: 'bg-bamboo/15 text-bamboo',
  warning: 'bg-rose-300/40 text-rose-600',
  error: 'bg-lacquer/15 text-lacquer',
  bamboo: 'bg-bamboo text-cream-100',
  flower: 'bg-flower/30 text-lacquer',
  navy: 'bg-navy-900 text-cream-100',
};

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: BadgeVariant;
}

export function Badge({ variant = 'default', className, ...rest }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium',
        variants[variant],
        className,
      )}
      {...rest}
    />
  );
}
